import { useMemo } from 'react';

import { DeviceIdItem, useDeviceIdList } from '@/api/deviceIdList';
import { useSpotterContext } from '@/context/SpotterContext';

export const useDeviceIdentity = (): DeviceIdItem | null => {
    const { spotterId } = useSpotterContext();
    const { data: deviceIdList } = useDeviceIdList();

    return useMemo(
        () => deviceIdList?.data?.devices.find((spotter) => spotter.spotterId === spotterId) ?? null,
        [deviceIdList?.data?.devices, spotterId]
    );
};
